import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight, MdOutlineDescription, MdOutlineHelpOutline } from "react-icons/md";
import Carrier from "src/components/Carrier/Carrier";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import { HOW_TO_USE_KEY, TERMS_KEY } from "../../../../../constants";

type Props = {
  usageInstructions: string;
  termsAndCondition: string;
  activeKey?: string;
  onChange?: (key: string | string[]) => void;
};

const GiftcardInstructionsMob: FC<Props> = ({ usageInstructions, termsAndCondition }) => {
  const { t } = useTranslation();
  const items = [
    {
      key: HOW_TO_USE_KEY,
      label: t("UserHistory.giftcard.howToUse"),
      content: usageInstructions,
      Icon: MdOutlineHelpOutline,
    },
    {
      key: TERMS_KEY,
      label: t("UserHistory.giftcard.termsAndConditions"),
      content: termsAndCondition,
      Icon: MdOutlineDescription,
    },
  ].filter((item) => !!item.content);

  if (!items.length) return null;

  return (
    <div className="flex w-full flex-col gap-3 text-start">
      {items.map(({ key, label, content, Icon }) => (
        <Carrier
          key={key}
          label={<span className="font-semibold">{label}</span>}
          renderTrigger={({ open }) => (
            <button
              type="button"
              onClick={open}
              className="bg-background-default outline-border-subtle flex w-full items-center gap-3 rounded-xl p-4 text-start outline transition-colors"
            >
              <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                <Icon className="h-5 w-5" />
              </div>
              <span className="text-font-default flex-1 text-sm font-semibold">{label}</span>
              <MdChevronRight className="text-icon-minimal h-5 w-5 shrink-0 rtl:-scale-x-100" />
            </button>
          )}
          renderSheet={() => <GiftcardHtml className="text-font-default flex flex-col gap-2 p-4 text-xs" html={content} />}
        />
      ))}
    </div>
  );
};

export default GiftcardInstructionsMob;
